// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ColorInput_wrapper__3t0Vi","colorInput":"ColorInput_colorInput__2IFZw","colorIndicator":"ColorInput_colorIndicator__opqTU"};